import React from 'react';

import { Icon } from '@vk-hr-tek/ui/Icon';

export const ANONYMOUS_OPTIONS = [
  { label: 'Да', value: '0' },
  { label: 'Нет', value: '1' },
];

export const SHOW_ANSWERS_OPTIONS = [
  { label: 'Да', value: '0' },
  { label: 'Нет', value: '1' },
];

export const ANSWER_OPTIONS = [
  {
    value: 'one',
    label: 'Один из списка',
    startIcon: (
      <Icon name="check_circle_outline" size="20" color="text.light.primary" />
    ),
  },
  {
    value: 'several',
    label: 'Несколько из списка',
    startIcon: (
      <Icon name="check_square_outline" size="20" color="text.light.primary" />
    ),
  },
  {
    value: 'text',
    label: 'Текст',
    startIcon: (
      <Icon name="article_outline" size="20" color="text.light.primary" />
    ),
  },
];
